import { getSimpleDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { CpDataApi } from 'cp-xhr';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';
import { CustomerType, getCustomerTypeEndpoint } from 'cpes-common';

const { reducer, fetchData } = getSimpleDataFetchSlice<CustomerType, DefaultBusinessMarketApiErrorCode>({
    dataName: 'customerType',
    fetchCallback() {
        return CpDataApi.get(getCustomerTypeEndpoint()).then(response => response.data);
    },
});

export default reducer;
export const fetchCustomerType = fetchData;
